import { create } from '@/store'
import { devtools } from 'zustand/middleware'
import { isRoleTeamLeader } from '@/utils/auth'
import { CustomerAssign } from '@/constants/user'

export const useCustomerListFilterStore = create(
  devtools(
    (set) => ({
      assign: isRoleTeamLeader() ? CustomerAssign.MyGroup : CustomerAssign.ALL,
      searchText: '',
      page: 1,
      pageSize: 10,
      filterModel: {
        fieldRelation: {
          between: 'and',
          inner: 'and',
        },
        fieldRule: {},
      },
      refreshField: new Date(),
      selectedFilter: null,
      selectedColumnKeys: [
        'name',
        'phone',
        'email',
        'dob',
        'source',
        'organization',
        'group',
        'city',
        'created_at',
      ],
      quickFilter: {
        filters: [],
        conditionRelation: 'and',
      },
      updateQuickFilter: (quickFilter) =>
        set((state) => ({ ...state, quickFilter })),
      setRefreshField: (date) => set({ refreshField: date }),
      setAssign: (assign) => set({ assign, page: 1 }),
      setSearchText: (searchText) => set({ searchText, page: 1 }),
      setPage: (page) => set({ page }),
      setPageSize: (pageSize) => set({ pageSize }),
      setFilterModel: (filterModel) => set({ filterModel, page: 1 }),
      setSelectedFilter: (selectedFilter) => set({ selectedFilter }),
      setSelectedColumnKeys: (selectedColumnKeys) =>
        set((state) => ({
          ...state,
          selectedColumnKeys,
        })),
      resetFilterModel: () =>
        set((state) => ({
          ...state,
          filterModel: {
            fieldRelation: {
              between: 'and',
              inner: 'and',
            },
            fieldRule: {},
          },
          page: 1,
        })),
    }),
    {
      name: 'customer-list-filter-store',
    },
  ),
)
